import { createSelector } from 'reselect';
import { standortStateSelector } from '../standort';
import _ from 'lodash';
import { pendingResponse } from '../../fetchStatus';

export const offersResponseSelector = createSelector([standortStateSelector], standortState => standortState.offers || pendingResponse);

export const offersSelector = createSelector([offersResponseSelector], offersResponse => _.get(offersResponse, 'data'));
